var _isReservation, _firstName, _lastName, ref, ref1, ref2, ref3, _preferredChannelOfCommunication, _customerComment;
const fromBookAppointmentMutationToBookedAppointment = (data)=>{
    var ref8, ref4, ref5, ref6, ref7;
    return data ? {
        id: data.id,
        isReservation: (_isReservation = data.isReservation) !== null && _isReservation !== void 0 ? _isReservation : false,
        startTime: new Date(data.startTime),
        endTime: new Date(data.endTime),
        child: data.child ? {
            firstName: (_firstName = data.child.firstName) !== null && _firstName !== void 0 ? _firstName : '',
            lastName: (_lastName = data.child.lastName) !== null && _lastName !== void 0 ? _lastName : '',
            dateOfBirth: data.child.dateOfBirth ? new Date(data.child.dateOfBirth) : null
        } : undefined,
        invitee: {
            firstName: (ref = (ref8 = data.invitee) === null || ref8 === void 0 ? void 0 : ref8.firstName) !== null && ref !== void 0 ? ref : '',
            lastName: (ref1 = (ref4 = data.invitee) === null || ref4 === void 0 ? void 0 : ref4.lastName) !== null && ref1 !== void 0 ? ref1 : '',
            email: (ref2 = (ref5 = data.invitee) === null || ref5 === void 0 ? void 0 : ref5.email) !== null && ref2 !== void 0 ? ref2 : '',
            phone: (ref3 = (ref6 = data.invitee) === null || ref6 === void 0 ? void 0 : ref6.phone) !== null && ref3 !== void 0 ? ref3 : ''
        },
        preferredChannelOfCommunication: (_preferredChannelOfCommunication = data.preferredChannelOfCommunication) !== null && _preferredChannelOfCommunication !== void 0 ? _preferredChannelOfCommunication : undefined,
        customerComment: (_customerComment = data.customerComment) !== null && _customerComment !== void 0 ? _customerComment : undefined,
        products: (ref7 = data.products) === null || ref7 === void 0 ? void 0 : ref7.map((product)=>{
            var ref20, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
            var ref18, ref19;
            return {
                name: product.displayName,
                price: {
                    amount: (ref18 = (ref20 = product.prices) === null || ref20 === void 0 ? void 0 : (ref9 = ref20.discountedPrice) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.price) === null || ref10 === void 0 ? void 0 : ref10.amount) !== null && ref18 !== void 0 ? ref18 : (ref11 = product.prices) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.originalPrice) === null || ref12 === void 0 ? void 0 : ref12.amount,
                    currencyCode: (ref19 = (ref13 = product.prices) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.discountedPrice) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.price) === null || ref15 === void 0 ? void 0 : ref15.currencyCode) !== null && ref19 !== void 0 ? ref19 : (ref16 = product.prices) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.originalPrice) === null || ref17 === void 0 ? void 0 : ref17.currencyCode
                },
                image: {
                    url: product.media.images[0].url
                }
            };
        })
    } : undefined;
};

export { fromBookAppointmentMutationToBookedAppointment };
//# sourceMappingURL=fromBookAppointmentMutationToBookedAppointment.js.map
